import React from 'react';
import styled from '@emotion/styled';
import {
  Color,
  FontWeight,
  colors,
  getBorderRadius,
  getHeight,
  getSpacing,
} from '@cabonline/ui-shared';
import { Text } from '../text';

interface CustomStyles {
  color?: Color;
  icon?: React.ReactElement;
  darkBackground?: boolean;
}

export interface LinkButtonProps extends CustomStyles {
  testID?: string;
  color?: Color;
  weight?: FontWeight;
  label: string;
  onClick: () => void;
  disabled?: boolean;
  darkBackground?: boolean;
}

const getTextColor = (color?: Color): Color => {
  if (color) {
    return color;
  }
  return colors.black;
};

const StyledButton = styled.button<CustomStyles>`
  line-height: normal;
  margin: 0;
  padding: 0 ${getSpacing('xxxs')};
  color: ${(p) => getTextColor(p.color)};
  display: flex;
  align-items: center;
  gap: ${getSpacing('xxs')};
  cursor: pointer;
  height: ${getHeight('m')};
  background: none;
  border: none;
  border-radius: ${getBorderRadius('s')};
  font: inherit;
  &:focus-visible {
    outline: ${(p) =>
      `2px solid ${p.darkBackground ? colors.white : colors.black}`};
  }
  &:disabled {
    cursor: not-allowed;
  }
`;

export const LinkButton: React.FC<LinkButtonProps> = ({
  testID = '',
  color = colors.black,
  weight = 'semi',
  label,
  onClick,
  icon,
  disabled = false,
  darkBackground = false,
}) => {
  return (
    <StyledButton
      type="button"
      data-testid={testID}
      color={color}
      onClick={onClick}
      disabled={disabled}
      darkBackground={darkBackground}
    >
      <Text
        color={disabled ? colors.gray2 : color}
        as="span"
        underline
        underlineOffset="xxxs"
        weight={weight}
      >
        {label}
      </Text>
      {icon}
    </StyledButton>
  );
};
